module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2LqUcrVfTtVUuuhHxzbWr6-0aa86e6ac9fd9a5f98b87b5e25b1f96b.jpg";